// extracted by mini-css-extract-plugin
export default {"launcher":"bm_PN","launcher__heading":"bm_PP","launcher__menu-item":"bm_PQ","launcher__options":"bm_PR","launcher__framework-style__select":"bm_PS form-control"};